import { useState } from 'react';
import { useListPick } from '../../../../../../../components/ListPicker/useListPick';
import { ClassificationTypeEntityEnum } from '../../../../../../classifications/classification.types';
import {
  CatalogClassificationType,
  UseClassificationTypeSelectProps,
} from '../interfaces/classificationTypeSelect.types';

const useClassificationTypeSelect = ({
  disabled,
  catalogId,
  initialClassificationTypeId,
}: UseClassificationTypeSelectProps) => {
  const [inputText, setInputText] = useState('');
  const [selectedId, setSelectedId] = useState<string | null>(initialClassificationTypeId ?? null);

  const listPickActions = useListPick<CatalogClassificationType>({
    url: `classification-types?entity=${ClassificationTypeEntityEnum.PRODUCT_COLOR}`,
    limit: 20,
    defaultQuery: {
      useAsTag: true,
      ...(catalogId ? { catalogId } : {}),
    },
    queryField: 'name',
    order: { name: 'ASC' },
  });

  const options = listPickActions.leftItems.reduce<CatalogClassificationType[]>((acc, item) => {
    if (item?.id && item?.name) {
      acc.push({ ...item, name: item.name.toUpperCase() });
    }
    return acc;
  }, []);

  const selectedClassificationType = options.find((option) => option.id === selectedId) ?? null;

  const handleChangeInput = (_: React.ChangeEvent<{}>, value: string) => {
    if (disabled) {
      return;
    }
    setInputText(value);
    listPickActions.onSearch(value);
  };

  return {
    options,
    inputText,
    listPickActions,
    handleChangeInput,
    selectedClassificationType,
    setSelectedId,
  };
};

export default useClassificationTypeSelect;
